<template>
  <div class="orphan-card" >
    <div class="gheom__card__wrapper">
      <div class="content">
        <span>{{orphans.gheoms.length}}</span>
        <div class="orphan__meta">
          <p class="title">Gheoms with no products</p>
          <div>
            <p class="subtitle">Last tested on</p>
            <a href="#">Explore Gheoms</a>
          </div>
        </div> 
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: [
    "orphans"
  ],
  data:function(){ 
    return {

    }
  },
  computed: {

  },
  methods: {
 
  }
}
</script>

<style scoped>
  .orphan-card {
    margin-top: calc(55px + 0.5rem);
  }
</style>